module.exports = __webpack_public_path__ + "static/media/circles.c1ce5b8f.svg";